<template>
  <validation-observer
    id="stepIntroForm"
    ref="form"
    tag="form"
    novalidate
    @submit.prevent="handleSubmit"
  >
    <vvs-input
      type="email"
      name="E-Posta"
      label="1. E-posta"
      placeholder="Vivense'de kullanacağınız e-posta adresini girin."
      validate="required|email|withoutEmoji|uniqueSupplierApplicationemail|uniqueEmail"
      validate-mode="lazy"
      v-model="form.email"
    ></vvs-input>

    <vvs-input
      type="tel"
      name="Telefon"
      label="2. Telefon"
      placeholder="0(___) ___ __ __"
      mask="0(###) ### ## ##"
      validate="required|min:16"
      validate-mode="lazy"
      v-model="form.phoneNumber"
    ></vvs-input>

    <vvs-textarea
      name="Firma Adı"
      label="3. Firma Adı"
      placeholder="Vergi levhasında bulunan ticaret ünvanını girin. Şahıs şirketi iseniz adınızı ve soyadınızı yazın."
      validate="required|withoutEmoji|min:2"
      maxlength="150"
      v-model="form.companyName"
      auto-resize
    ></vvs-textarea>

    <vvs-recaptcha
      v-if="showRecaptcha"
      name="Google Recaptcha"
      validate="required"
      v-model="googleVerifyKey"
    ></vvs-recaptcha>

    <vvs-submit-button
      title="İLERİ &gt;"
      description="* doldurulması zorunlu alan"
    ></vvs-submit-button>
  </validation-observer>
</template>

<script>
import stepsMixin from './../steps.mixin';

export default {
  name: 'StepIntro',
  mixins: [stepsMixin],
};
</script>
